import path from 'node:path'

export function schemaFileCandidates(schemasDir: string, name: string): string[] {
  return [path.join(schemasDir, `${name}.json`), path.join(schemasDir, 'forms', `${name}.json`)]
}
